import React from "react";
import { Document, Page, Text, View, StyleSheet,Image } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: { padding: 30, fontSize: 12, fontFamily: "Helvetica", color: "#101828" },
  heading: {
    textAlign: "center",
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 20,
    color: "#003149",
  },
  recordGroup: {
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    borderBottomStyle: "solid",
  },
  row: { flexDirection: "row", alignItems: "flex-start", marginBottom: 6 },
  label: { width: 90, color: "#344054", fontWeight: "bold" },
  value: { flex: 1, paddingLeft: 8, color: "#101828", textAlign: "right" },
  valueWrap: { flex: 1, paddingLeft: 8, color: "#101828", textAlign: "left" },
});

const ExportAttendanceHistoryPDF = ({ data ,logo}) => {
  const { t } = useTranslation();

  return (
    <Document>
      <Page size="A4" style={styles.page}>

    {logo && (
          <Image
            src={logo}
            style={{ width: 120, alignSelf: "center", marginBottom: 10 }}
          />
        )}
        
        <Text style={styles.heading}>
     {t("attendanceHistory.heading")}        </Text>

        {data.map((row, i) => (
          <View key={i} style={styles.recordGroup}>

       

            <View style={styles.row}>
              <Text style={styles.label}>{t("attendanceHistory.tableHeaders.fullName")}:</Text>
              <Text style={styles.value}>{row.fullName}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("attendanceHistory.tableHeaders.date")}:</Text>
              <Text style={styles.value}>{row.date}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("clockIn")}:</Text>
              <Text style={styles.value}>{row.checkIn}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("clockOut")}:</Text>
              <Text style={styles.value}>{row.checkOut}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("breakStart")}:</Text>
              <Text style={styles.value}>{row.breakStart}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("breakEnd")}:</Text>
              <Text style={styles.value}>{row.breakEnd}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("attendanceHistory.tableHeaders.location")}:</Text>
              <Text style={styles.valueWrap}>{row.location}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("attendanceHistory.tableHeaders.details")}:</Text>
              <Text style={styles.value}>{row.details}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("attendanceHistory.tableHeaders.status")}:</Text>
              <Text style={styles.value}>{row.status}</Text>
            </View>

          </View>
        ))}

      </Page>
    </Document>
  );
};

export default ExportAttendanceHistoryPDF;
